<template>
    <div class="zona-subida-global">
        <transition name="bounce-slide">
            <div v-if="mostrarBanner" class="banner-custom d-flex justify-content-between align-items-center p-2">
                <CRow>
                    <CCol sm="9" md="9" lg="9" xl="9">
                        <span class="text-white">{{ mensajeBanner }}</span>
                    </CCol>
                    <CCol sm="3" md="3" lg="3" xl="3" class="d-flex justify-content-end">
                        <CButton size="sm" color="light" class="mr-2" @click="eliminarTodosLosArchivos(provieneBannerCerrar); mostrarBanner = false">
                            Sí
                        </CButton>
                        <CButton size="sm" color="light" @click="mostrarBanner = false; provieneBannerCerrar = false">
                            No
                        </CButton>
                    </CCol>
                </CRow>
            </div>
        </transition>


        
        <input type="file" ref="input" @change="manejarSeleccion" multiple style="display: none" />

        <CButtonGroup class="mx-1">
            <CButton 
                size="sm"
                class="btnPrincipalVapp mr-2 px-2 py-1 text-sm" 
                @click="abrirSelector">
                <CIcon :name="$utils.iconosGenerales('agregar')" /> 
                Agregar Documentos
            </CButton>
            <CButton 
                v-if="archivos.length > 0 && !archivos.some(a => a.uploading)"
                :disabled="!archivos.some(a => !a.success)"
                size="sm"
                class="btn btnPrincipalVapp mr-2 px-2 py-1 text-sm"
                @click="subirArchivos()">
                <CIcon :content="$options.freeSet.cilCloudUpload" />
                Subir Todo
            </CButton>
            <CButton 
                v-if="archivos.some(a => a.uploading)"
                size="sm"
                class="btn btn-danger mr-2 px-2 py-1 text-sm" 
                @click="cancelarTodasLasSubidas()">
                <CIcon :content="$options.freeSet.cilXCircle" />
                Detener Todo
            </CButton>
            <CButton 
                v-if="archivos.length > 0 && !archivos.some(a => a.uploading || a.active)"
                size="sm"
                class="btn btn-danger mr-2 px-2 py-1 text-sm" 
                @click="eliminarTodosLosArchivos(false)">
                <CIcon :name="$utils.iconosGenerales('quitar')" />
                Quitar Documentos
            </CButton>
            <div class="divisor"></div>
            <CButton
                size="sm"
                class="btn btnPrincipalVapp ml-2 px-2 py-1 text-sm"
                @click.prevent="eliminarTodosLosArchivos(true)"
            >
                <CIcon :content="$options.freeSet.cilBan" />
                Cerrar subir Documentos
            </CButton>
        </CButtonGroup>

        <CRow>
            <CCol>
                <!--Filtros-->
                <div class="mt-2" v-if="archivos.length > 0">
                    <select v-model="filtroEstado" class="form-control form-control-sm" style="width: 180px;">
                        <option value="todos">Todos</option>
                        <option value="pendientes">Pendientes</option>
                        <option value="subiendo">Subiendo</option>
                        <option value="procesados">Procesados</option>
                        <option value="procesando">Procesando</option>
                        <option value="error">Con error</option>
                    </select>
                </div>
                
            </CCol>
        </CRow>

        <transition-group
            name="fade-slide"
            tag="div"
            class="lista-archivos">
            <div
                v-for="(archivo, index) in archivos.slice().sort((a, b) => {
                    const aProcesado = a.success || a.error;
                    const bProcesado = b.success || b.error;
                    return aProcesado - bProcesado; // false (0) va antes que true (1)
                })
                .filter(archivo => {
                    if (filtroEstado === 'todos') return true;
                    if (filtroEstado === 'pendientes') return !archivo.success && !archivo.error && !archivo.uploading && !archivo.active;
                    if (filtroEstado === 'procesados') return archivo.success;
                    if (filtroEstado === 'error') return archivo.error;
                    if (filtroEstado === 'procesando') return !archivo.success && !archivo.error && !archivo.uploading && archivo.active;
                    if (filtroEstado === 'subiendo') return archivo.uploading || archivo.active;
                    return true;
                })"
                :key="archivo.id || archivo.name"
                class="mt-2"
            >
                <CCard class="mb-2">
                    <CCardHeader>
                        <div class="card-header-actions float-left" >
                            <CLink v-show="archivo.success || archivo.error" class="card-header-action btn-minimize" @click="archivo.mostrarMas = !archivo.mostrarMas">
                                <CIcon v-show="archivo.mostrarMas" :content="$options.freeSet.cilChevronTop" />
                                <CIcon v-show="!archivo.mostrarMas" :content="$options.freeSet.cilChevronBottom" />
                            </CLink>
                        </div>
                        <CRow>
                            <CCol sm="9" md="9" lg="9">
                                <CRow>
                                    <CCol><span class="text-truncate d-inline-block w-100" v-tippy="getBaseTippy(`${archivo.name}`)">({{ archivo.size | prettyBytes }}) {{ archivo.name }}</span></CCol>
                                </CRow>
                                <CRow>
                                    <CCol class="center-content">
                                        <CProgress style="width: 40%;"
                                            :value="parseFloat(archivo.progress)"
                                            :precision="2"
                                            :animated="true"
                                            :color="archivo.error ? 'danger' : 'success'"
                                            />
                                        <span class="ml-1">{{parseFloat(archivo.progress)}}%</span> 
                                        <span class="ml-1" v-show="archivo.uploading">{{ archivo.speed | prettyBytes }}/s</span>
                                        <span class="ml-1">
                                            <CBadge v-if="archivo.success" :style="{ 'color': '#ffffff', 'background-color': getColorEstado(archivo)}">
                                                
                                                {{archivo.status}}
                                            </CBadge>
                                            <CBadge v-else :color="getColorEstado(archivo)">
                                                {{archivo.status}}
                                            </CBadge>
                                        </span>
                                    </CCol>
                                </CRow>
                            </CCol>
                            <CCol sm="3" md="3" lg="3" class="d-flex justify-content-center align-items-center">
                                <span v-if="!archivo.uploading && archivo.active" style="color: #e03232" class="pi pi-spinner imgr"></span>
                                <CDropdown v-else
                                    @click="opcionDrpdwnArchivos(archivo)"
                                    color="secondary"
                                    split
                                    toggler-text="Split Dropdown"
                                    class="mr-1">
                                    <template #toggler-content ><!-- :class="isActualizandoEmpresas?'pi-spin':''"-->
                                        
                                        <span style="font-size: 11px;">
                                            <!--<CIcon v-if="!archivo.uploading && archivo.active" size="xl" style="color: #1f1b4e" :content="$options.freeSet.cilCheckAlt" />-->
                                            <CIcon v-if="archivo.uploading && archivo.active" style="color: #e03232" name="cil-x-circle" />
                                            <CIcon v-else-if="archivo.error && !archivo.active && archivo.status !== 'SizeError'" style="color: #17a2b8" :content="$options.freeSet.cilLoopCircular" />
                                            <CIcon v-else-if="archivo.error && archivo.status === 'SizeError'" style="color: #e03232" :content="$options.freeSet.cilTrash" />
                                            <CIcon v-else style="color: #1f1b4e" :content="$options.freeSet.cilCloudUpload" />
                                        </span>

                                    </template>
                                    <div role="group">
                                        <CDropdownHeader  v-show="archivo.success || archivo.error" class="tituloErrorHeader">
                                            <div class="d-flex center-content">
                                                <CIcon
                                                    style="color:#f9b115"
                                                    :content="$options.freeSet.cilWarning"
                                                /> 
                                            </div>
                                            <span v-if="archivo.error">
                                                <span v-if="archivo.status === 'Cancelado'">
                                                    Subida cancelada por el usuario
                                                </span>
                                                <span v-if="archivo.status === 'SizeError'">
                                                    {{ archivo.errorMensaje }}
                                                </span>
                                                <span v-else>
                                                    {{ archivo.response.mensajeGeneral }}
                                                </span>
                                            </span>
                                        </CDropdownHeader>
                                        <CDropdownItem :disabled="archivo.active" @click="eliminarArchivo(archivo)">
                                            <CIcon 
                                                class="mr-1"
                                                style="color: #e03232" 
                                                :content="$options.freeSet.cilTrash" /> Quitar Documento
                                        </CDropdownItem>
                                    </div>
                                </CDropdown>
                            </CCol>
                        </CRow>
                    </CCardHeader>
                    <CCollapse :show="archivo.mostrarMas" :duration="400">
                        <CCardBody>
                            <span v-if="archivo.success">{{ archivo.response.mensajeGeneral }}</span>
                            <span v-else-if="archivo.error">
                                <span v-if="archivo.status === 'Cancelado'">
                                    Subida cancelada por el usuario
                                </span>
                                <span v-if="archivo.status === 'SizeError'">
                                    {{ archivo.errorMensaje }}
                                </span>
                                <span v-else>
                                    {{ archivo.response.mensajeGeneral }}
                                </span>
                            </span>
                        </CCardBody>
                    </CCollapse>
                </CCard>
            </div>
        </transition-group>
    </div>
</template>

<script>
    import cons from '@/const'
    import { freeSet } from "@coreui/icons";
    import { CCol, CIcon } from '@coreui/vue';
    import axios from "axios"
    import { es } from 'date-fns/locale';
    import * as util from '@/views/utils/utilsFunctions'


export default {
    name: "SubirArchivos",
    freeSet,
    props: {
        idCliente: Number,
        tipoDocumentoSelected: Object,
        mesSelected: Object,
        periodoSelected: Object,
        mostrarPeriodo: Boolean,
        mostrarSubirDocumentos: Boolean
    },
    data() {
        return {
            archivos: [],
            urlBase: cons.port+"://" + cons.ipServer,
            tokenLogin: JSON.parse(this.$cookie.get('userLogginToken')).tokenUsuario,
            subiendoGeneral: false,
            detenerTodo: false,
            mostrarBanner: false,
            mensajeBanner: "¿Está seguro de quitar todos los documentos?",
            provieneBannerCerrar: false,
            filtroEstado: 'todos',
            
        }
    },
    mounted() {
        // Escuchar eventos globales de drag & drop
        window.addEventListener('dragover', this.evitarPorDefecto)
        window.addEventListener('drop', this.manejarDrop)
    },
    beforeDestroy() {
        // Limpieza de eventos al destruir el componente
        window.removeEventListener('dragover', this.evitarPorDefecto)
        window.removeEventListener('drop', this.manejarDrop)
    },
    methods: {
        // FUNCIONES DE EVENTOS GLOBALES / UI
        evitarPorDefecto(e) {
            e.preventDefault()
            e.stopPropagation()
        },
        abrirSelector() {
            this.$refs.input.click()
        },
        cerrarSubirDocumentos() {
            this.$emit("cerrarSubirDocumentos")
        },

        // MANEJO DE ARCHIVOS (input, drop, creación)
        manejarSeleccion(evento) {
            this.evitarPorDefecto(evento)
            if (!this.mostrarSubirDocumentos){
                if (evento.dataTransfer.target.length > 0) 
                    this.mostrarNotificaciones(1, "Para agregar documentos, primero debe abrir la sección de subir documentos")
                return
            }

            const nuevosArchivos = Array.from(evento.target.files).map(file => this.crearArchivoExtendido(file))
            this.archivos.push(...nuevosArchivos)
        },
        manejarDrop(evento) {
            this.evitarPorDefecto(evento)
            if (!this.mostrarSubirDocumentos){
                if (evento.dataTransfer.files.length > 0) 
                    this.mostrarNotificaciones(1, "Para agregar documentos, primero debe abrir la sección de subir documentos")
                return
            }
            const nuevosArchivos = Array.from(evento.dataTransfer.files).map(file => this.crearArchivoExtendido(file))
            this.archivos.push(...nuevosArchivos)
        },
        crearArchivoExtendido(file) {
            let maxSize = 1024 * 1024 * 100
            let error = false
            let status = 'En Espera'
            let errorMensaje = ''
            let dateResponse = null
            let date = new Date()
            if (file.size > maxSize) {
                error = true
                errorMensaje = `El archivo ${file.name} tiene un tamaño no permitido. Debe ser menor a 100MB.`
                status = 'SizeError'
                dateResponse = new Date()
            }
            return {
                id: Date.now().toString(36) + Math.random().toString(36).substr(2, 9),
                file,
                name: file.name,
                size: file.size,
                progress: 0,
                speed: 0,
                error: error,
                success: false,
                active: false,
                uploading: false,
                status: status,
                cancelTokenSource: null,
                mostrarMas: false,
                errorMensaje: errorMensaje,
                date: date,
                dateResponse: dateResponse,
            }
        },

        // FUNCIONES DE BOTONES Y ACCIONES DEL USUARIO
        opcionDrpdwnArchivos(archivo) {
            if (archivo.uploading && archivo.active){
                this.cancelarSubida(archivo)
            } 
            else if(!archivo.uploading && archivo.active){
                this.mostrarNotificaciones(1, `El Documento ${archivo.name} se está procesando`)
            }
            else if (archivo.error && !archivo.active && archivo.status !== 'SizeError'){
                this.reiniciarSubida(archivo)
            } else if(archivo.error && archivo.status === 'SizeError'){
                this.eliminarArchivo(archivo)
            } else {
                this.subirArchivo(archivo)
            }
        },
        eliminarArchivo(archivo) {
            if (archivo.uploading && archivo.cancelTokenSource) {
                archivo.cancelTokenSource.cancel("Eliminado por el usuario")
            }
            this.archivos = this.archivos.filter(a => a !== archivo)
        },
        eliminarTodosLosArchivos(cerrar = false) {
            if (this.archivos.length === 0 && cerrar) {
                this.cerrarSubirDocumentos()
                return
            }
            if(!this.mostrarBanner){
                if(cerrar){
                    this.mensajeBanner = "¿Está seguro de cerrar la subida de documentos, se quitaran todos los documentos?"
                    this.provieneBannerCerrar = true
                }
                this.mostrarBanner = true
            } else if(this.mostrarBanner){
                this.archivos.forEach(archivo => {
                    if (archivo.uploading && archivo.cancelTokenSource) {
                        archivo.cancelTokenSource.cancel("Eliminado por el usuario (global)")
                    }
                })
                this.archivos = []
                if(cerrar){
                    this.provieneBannerCerrar = false
                    this.cerrarSubirDocumentos()
                }
            }
        },
        reiniciarSubida(archivo) {
            archivo.progress = 0
            archivo.speed = 0
            archivo.error = false
            archivo.success = false
            archivo.status = 'Pendiente'
            archivo.uploading = false
            archivo.active = true
            archivo.cancelTokenSource = null
            archivo.response = null
            this.subirArchivo(archivo)
        },
        cancelarSubida(archivo) {
            if (archivo.uploading && archivo.cancelTokenSource) {
                archivo.cancelTokenSource.cancel("Subida cancelada por el usuario")
            }
        },
        cancelarTodasLasSubidas() {
            this.detenerTodo = true
            this.archivos.forEach(archivo => {
                if (archivo.uploading && archivo.cancelTokenSource) {
                    archivo.cancelTokenSource.cancel("Cancelado por el usuario (global)")
                }
                if (!archivo.uploading && archivo.active) {
                    archivo.status = 'Cancelado'
                    archivo.error = true
                    archivo.active = false
                }
            })
        },

        // PROCESO DE SUBIDA
        async subirArchivos() {
            if (this.detenerTodo){
                this.detenerTodo = false
            }
            let archivosSubir = []
            this.archivos.forEach(archivo => {
                if (archivo.success) return
                archivo.active = true
                if (archivo.status === 'Cancelado') {
                    archivo.status = 'En Espera'
                    archivo.error = false
                    archivo.success = false
                    archivo.uploading = false
                    archivo.progress = 0
                    archivo.speed = 0
                    archivo.cancelTokenSource = null
                }
                archivosSubir.push(archivo)
            })

            const archivosPendientes = [...archivosSubir]
            const maxConcurrentes = 3
            let activos = []

            const ejecutarSiguiente = async () => {
                while ((archivosPendientes.length > 0 || activos.length > 0) && !this.detenerTodo) {
                    while (activos.length < maxConcurrentes && archivosPendientes.length > 0 && !this.detenerTodo) {
                        const archivo = archivosPendientes.shift()
                        const promesa = this.subirArchivo(archivo).finally(() => {
                            activos = activos.filter(p => p !== promesa)
                        })
                        activos.push(promesa)
                    }
                    if (activos.length > 0) {
                        await Promise.race(activos)
                    }
                }
            }

            await ejecutarSiguiente()
        },
        async subirArchivo(archivo){
            return new Promise((resolve) => {
                archivo.uploading = true
                archivo.status = 'Subiendo'
                archivo.cancelTokenSource = axios.CancelToken.source()
                if (!archivo.active) archivo.active = true

                const formData = new FormData()
                formData.append("archivo", archivo.file)

                let infoArchivo = {
                    "idCliente": this.idCliente,
                    "tipoDocumento": this.tipoDocumentoSelected.valor,
                    "mes": this.mesSelected.valor,
                    "anio": this.periodoSelected.valor,
                    "tipoBD": "REMU",
                    "mostrarPeriodo": (this.tipoDocumentoSelected.valor =='contratos') ? this.mostrarPeriodo : true
                }
                formData.append("infoArchivo", JSON.stringify(infoArchivo))

                axios({
                    method: "POST", 
                    "url": `${this.urlBase}/subir_archivos_empresa2/`,
                    data: formData,
                    cancelToken: archivo.cancelTokenSource.token,
                    "headers": {
                        'Authorization': this.tokenLogin,
                        'Content-Type': 'multipart/form-data'
                    },
                    onUploadProgress: (progressEvent) => {
                        if (!archivo._uploadTrack) {
                            archivo._uploadTrack = {
                                lastTime: Date.now(),
                                lastLoaded: 0
                            }
                        }
                        const now = Date.now()
                        const tiempoTranscurrido = (now - archivo._uploadTrack.lastTime) / 1000
                        const bytesSubidos = progressEvent.loaded - archivo._uploadTrack.lastLoaded
                        const velocidad = tiempoTranscurrido > 0 ? bytesSubidos / tiempoTranscurrido : 0

                        archivo._uploadTrack.lastTime = now
                        archivo._uploadTrack.lastLoaded = progressEvent.loaded

                        const nuevoProgreso = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                        if (parseFloat(archivo.progress) !== nuevoProgreso) {
                            archivo.progress = nuevoProgreso.toFixed(2)
                            archivo.speed = velocidad
                        }
                        if (progressEvent.loaded === progressEvent.total && archivo.estado !== 'procesando') {
                            archivo.uploading = false
                            archivo.status = 'Procesando'
                        }
                    }
                }).then(result => {
                    archivo.active = false
                    archivo.success = true
                    archivo.status = 'Finalizado'
                    archivo.uploading = false
                    archivo.response = result.data
                    archivo.dateResponse = new Date()
                    resolve(result)
                }).catch(error => {
                    if (axios.isCancel(error)) {
                        archivo.active = false
                        archivo.status = 'Cancelado'
                        archivo.error = true
                    } else {
                        archivo.active = false
                        archivo.status = 'Problemas'
                        archivo.error = true
                        archivo.speed = 0
                        archivo.response = error.response.data
                    }
                    archivo.uploading = false
                    archivo.dateResponse = new Date()
                    resolve(error)
                }).finally(() => {
                    util.manejoHistorialDocumentos(archivo, 'Subir Documentos')
                    archivo.abortController = null
                })
            })
        },

        // FUNCIONES UTILITARIAS
        getColorEstado(archivo) {
            if (archivo.success) return '#2eb85c'
            else if (archivo.active && parseInt(archivo.progress) < 100) return 'warning'
            else if (archivo.active && parseInt(archivo.progress) === 100) return 'warning'
            else if (archivo.error) return 'danger'
            else return "secondary"
        },
        
    }

}
</script>

<style scoped>
.zona-subida-global {
    padding: 5px 30px 30px 30px;
    text-align: center;
}

.divisor {
  width: 1px;
  background-color: #ccc;
  height: 24px;
  align-self: center;
}

.bounce-slide-enter-active {
  animation: bounceInDown 0.6s both;
}
.bounce-slide-leave-active {
  animation: bounceOutUp 0.4s both;
}

@keyframes bounceInDown {
  0% {
    opacity: 0;
    transform: translateY(-200px);
  }
  60% {
    opacity: 1;
    transform: translateY(30px);
  }
  80% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0);
  }
}

@keyframes bounceOutUp {
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  20% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(-200px);
    opacity: 0;
  }
}
.alert {
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  border-radius: 8px;
}
.banner-custom {
  background-color: #2E2860; /* Tu color personalizado */
  color: #ffffff; /* Texto blanco */
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  margin-bottom: 2%;
}

.fade-slide-enter-active, .fade-slide-leave-active {
  transition: all 0.4s ease;
}
.fade-slide-enter-from, .fade-slide-leave-to {
  opacity: 0;
  transform: translateX(20px);
}

.tituloErrorHeader {
    max-width: 220px;
    background-color: #fff3cd;
    color: #856404;
    padding: 6px 10px;
    border-radius: 6px;
    font-size: 9px;
    white-space: normal;
    word-wrap: break-word;
    line-height: 1.2;
    text-align: center;
}

.btn-icon {
  background: none;
  border: none;
  padding: 4px;
  margin: 0 2px;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s ease;
}

.btn-icon:hover {
  background: rgb(255, 255, 255);
}

.btn-icon.success { color: white; background: linear-gradient(135deg, #1f1b4e, #2e2a6f, #3b378e, #4a46a0, #514ec2, #6a67e5); }  /* verde */
.btn-icon.info { color: #17a2b8; }     /* celeste */
.btn-icon.danger { color: white; background: #e03232; }   /* rojo */
</style>